@if (stakeables$ | async; as stakeables) {
  <div class="bp-search-alt">
    <bp-search-bar
      [debounceTime]="searchInputDelay"
      [placeholder]="'search_bar_placeholder_buy' | translate"
      (searchValueChange)="fetchFilteredList($event, selectedOption)">
    </bp-search-bar>
  </div>
  	<!-- Risk warning needed for UK -->
	<app-uk-risk-summary
		[titleKey]="'uk_finprom_risk_summary_stake_title'"
		[summaryKey]="earnOnStablecoinEnabled ? 'uk_finprom_risk_summary_stake_text' : 'uk_finprom_risk_summary__stake_text'"
		[classes]="['mb-20', 'mt-20']">
	</app-uk-risk-summary>
  	<!-- Performance indicator needed for UK -->
	<div class="mb-20 font-size-13 flex gap-1">
		<img
			src="/assets/images/icons/icon-chart.svg"
			alt="image-icon" 
			class="performance-indicator-icon" />
		{{ "performance_indicators_7_days_timeframe" | translate }}
	</div>
  <div class="bp-select-alt">
    <bp-select
      id="assetFilter"
      [options]="filterOptions"
      [(selectedValue)]="selectedOption"
    (selectedValueChange)="fetchFilteredList(searchInput, $event)"></bp-select>
  </div>
  <!-- Error state -->
  @if (hasError$ | async) {
    <tradable-list-empty (refetchData)="fetchStakingData()"></tradable-list-empty>
  } @else {
    <div class="labels">
      <span>{{ "asset" | translate }}</span>
      <span>{{ "available_to_stake_header" | translate }}</span>
      <!-- Specific copies needed for UK -->
      <span>{{ "uk_finprom_estimated_rewards" | translate }}</span>
    </div>
    @for (stakeable of stakeables; track stakeable; let first = $first; let last = $last) {
      <stakeable-list-item
        bpArrowNav
        [first]="first"
        [last]="last"
        [tabindex]="0"
        [stakeable]="stakeable"
        [fiat]="fiat"
        (click)="onSelect(stakeable)"
        (keydown.enter)="onSelect(stakeable)">
      </stakeable-list-item>
    }
  }
  <!-- Stakeable List -->
  <!-- Loading spinner -->
  @if (isLoading$ | async) {
    <loading-spinner></loading-spinner>
  }
}
